/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                                 from 'react';
import Helmet                                from 'react-helmet';
import BackgroundImage                       from '../../images/terrace-5.jpg';
import { PicturePage }                       from '../templates/PicturePage';
import { LargeResponsiveHeading, LargeText } from '../atoms/StyledTypography';
import { StyledVerticalFlow }                from '../atoms/StyledVerticalFlow';
import { StyledSemiOpaqueBlock }             from '../atoms/StyledSemiOpaqueBlock';
import { IconRobot }                         from "../atoms/IconRobot";


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const NotFound = () => (
    <PicturePage picture={BackgroundImage}>
        <Helmet title="Page not found | Price Paid Data" />
        <div>
            <StyledSemiOpaqueBlock>
                <StyledVerticalFlow align="center">
                    <LargeResponsiveHeading> Oh No...</LargeResponsiveHeading>
                    <LargeText>We're not quite sure what went wrong but this is not the page you are looking for.</LargeText>
                </StyledVerticalFlow>
                <StyledVerticalFlow align="center">
                    <IconRobot/>
                </StyledVerticalFlow>
            </StyledSemiOpaqueBlock>
        </div>
    </PicturePage>
);



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js